import { Component, OnInit, Input } from '@angular/core';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.css']
})
export class TileComponent implements OnInit {

  constructor(private rootScopeService: RootScopeService,private _router: Router) {
    this.getRootScopeData();
  }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  @Input() tileData:any;

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;

  }

  gotoTile():void{
    if(this.tileData.maintenanceUrl){
      localStorage.setItem("maintenanceUrl",this.tileData.maintenanceUrl);
    }
    if(this.tileData.quickFilterStatus){
      localStorage.setItem("quickFilterStatus",this.tileData.quickFilterStatus);
    }
    window.location.href = this.tileData.tileUrl;
  }

}
